import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    Paper,
} from '@mui/material';
import {
    TrendingUp,
    Receipt,
    Payment,
    AccountBalance,
} from '@mui/icons-material';

const StatCard: React.FC<{
    title: string;
    value: string;
    icon: React.ReactNode;
    color: string;
}> = ({ title, value, icon, color }) => (
    <Card sx={{ height: '100%' }}>
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box
                    sx={{
                        backgroundColor: color,
                        borderRadius: '50%',
                        p: 1,
                        mr: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {React.cloneElement(icon as React.ReactElement, { sx: { color: 'white' } })}
                </Box>
                <Typography variant="h6" component="div">
                    {title}
                </Typography>
            </Box>
            <Typography variant="h4" component="div" fontWeight="bold">
                {value}
            </Typography>
        </CardContent>
    </Card>
);

export const DashboardPage: React.FC = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Dashboard
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                        title="Ventas del Mes"
                        value="$2,450,000"
                        icon={<TrendingUp />}
                        color="#1976d2"
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                        title="Facturas Pendientes"
                        value="15"
                        icon={<Receipt />}
                        color="#dc004e"
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                        title="Boletas Emitidas"
                        value="127"
                        icon={<Payment />}
                        color="#2e7d32"
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                        title="Saldo en Caja"
                        value="$890,000"
                        icon={<AccountBalance />}
                        color="#ed6c02"
                    />
                </Grid>

                <Grid item xs={12} md={8}>
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h6" gutterBottom>
                            Actividad Reciente
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                                • Factura #2024-001 emitida por $150,000
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                • Boleta #2024-089 emitida por $45,000
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                • Pago recibido por $200,000
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h6" gutterBottom>
                            Próximos Vencimientos
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                                • Declaración F29 - 12 días
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                • IVA Débito Fiscal - 8 días
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                • Pago PPM - 15 días
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}; 